/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import { Typography } from "@mui/material";
import { useRouter } from "next/router";
import Breadcrumbs from "@mui/material/Breadcrumbs";

const Breadcrumb: React.FC = () => {
    const router = useRouter();
    // first take out any url parameters so that they are not included in breadcrumb
    const asPathWithoutQuery = router.asPath.split("?")[0];
    // get each crumb in breadcrumb by splitting url path by "/"
    const pathParts = asPathWithoutQuery.split("/");

    const breadcrumbs = pathParts.map((part, index) => {
        // create each crumb's full href redirect path by joining all previous crumbs behind it with "/"
        const hrefPath = pathParts.slice(0, index + 1).join("/");
        let crumb = part;
        // if current crumb/path is a number or part of a whitelist that gives context, reformat it so that we're not just showing a number in the breadcrumbs
        const formattedWhileList: string[] = [
            "editChallengeGroup",
            "challenges",
        ];
        if (
            /^-?\d+$/.test(part) ||
            formattedWhileList.indexOf(pathParts[index - 1]) >= 0
        ) {
            crumb = `${pathParts[index - 1]}  ${part}`;
        }
        const removeFromCrumbs: string[] = [
            "course",
            "module",
            "lesson",
            "challengeGroup",
            "challenges",
            "editChallenge",
            "editChallengeGroup",
            "editChallengeQuestion",
        ];
        // exclude dynamic pages from breadcrumbs that don't have any content without an additional path parameter (i.e. each of these pages should always be followed by a course/module/lesson id)
        if (removeFromCrumbs.indexOf(part) < 0) {
            return (
                <Typography
                    key={part}
                    onClick={() => {
                        router.push(`${hrefPath}`);
                    }}
                    sx={{
                        "&:hover": {
                            textDecoration: "underline",
                        },
                        cursor: "pointer",
                        fontWeight:
                            index === pathParts.length - 1 ? "bold" : "normal",
                    }}
                >
                    {crumb}
                </Typography>
            );
        }
    });

    return (
        <Breadcrumbs
            separator="›"
            aria-label="breadcrumb"
            sx={{ marginTop: "20px" }}
        >
            {breadcrumbs}
        </Breadcrumbs>
    );
};

export default Breadcrumb;
